import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { StyleProps } from "./filter_color_button.types";

export const useStyles = makeStyles<Theme, StyleProps>(
  ({ palette, spacing }) => ({
    button: {
      backgroundColor: (props) => props.color,
      borderRadius: spacing(1.5),
      height: spacing(4),
      minWidth: spacing(4),
    },
    "button--bordered": {
      border: `solid 1px ${palette.primary.main}`,
    },
    "button--gradient": {
      background:
        "conic-gradient(red,orange, yellow, lime, aqua, blue, magenta, red)",
    },
    check: {
      "$button--bordered:hover &": {
        color: `${palette.primary.main} !important`,
        opacity: 0.7,
      },
      "$button:hover &": {
        color: "white",
        opacity: 0.7,
      },
      height: spacing(2.5),
      opacity: 0,
    },
    "check--active": {
      "$button &": {
        color: "white",
      },
      "$button--bordered &": {
        color: `${palette.primary.main} !important`,
      },
      opacity: 1,
    },
  }),
);
